import React, { useEffect, useState } from 'react';
import { Info, X } from 'lucide-react';
import { useLanguage } from './TranslationProvider';
// Aviso profesional: los servicios oficiales solo se ofrecen en inglés y español.
// Se muestra traducido al idioma activo, es cerrable y reaparece en cada nueva sesión.
const NOTICE_TEXT: Record<string, string> = {
  es: 'Información importante: este sitio está disponible en varios idiomas para facilitar el acceso a la información. Los servicios oficiales y la atención al público se ofrecen únicamente en inglés y español.',
  en: 'Important information: This website is available in multiple languages to make information easier to access. Official services and public assistance are provided only in English and Spanish.',
  fr: "Information importante : ce site est disponible en plusieurs langues pour faciliter l'accès à l'information. Les services officiels et l'assistance au public sont fournis uniquement en anglais et en espagnol.",
  'zh-CN': '重要信息：本网站提供多种语言，以便更轻松地获取信息。官方服务和公共协助仅以英语和西班牙语提供。',
  'zh-TW': '重要資訊：本網站提供多種語言，以便更輕鬆地取得資訊。官方服務與公共協助僅以英語和西班牙語提供。',
  ko: '중요 정보: 이 웹사이트는 정보 접근을 돕기 위해 여러 언어로 제공됩니다. 공식 서비스와 대민 지원은 영어와 스페인어로만 제공됩니다.',
  hy: 'Կարևոր տեղեկություն. այս կայքը հասանելի է մի քանի լեզուներով՝ տեղեկատվության հասանելիությունը հեշտացնելու համար: Պաշտոնական ծառայությունները և հանրային աջակցությունը տրամադրվում են միայն անգլերեն և իսպաներեն:',
  tl: 'Mahalagang impormasyon: Available ang website na ito sa maraming wika upang mas madaling ma-access ang impormasyon. Ang mga opisyal na serbisyo at tulong sa publiko ay ibinibigay lamang sa Ingles at Espanyol.'
};
const DISMISS_KEY = 'serviceNoticeDismissed';
export function ServiceNotice() {
  const {
    lang
  } = useLanguage();
  const [visible, setVisible] = useState(false);
  // Mostrar al cargar, salvo que ya se haya cerrado en esta sesión.
  useEffect(() => {
    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(DISMISS_KEY) === 'true';
    } catch {
      /* sessionStorage bloqueado */
    }
    if (!dismissed) setVisible(true);
  }, []);
  const close = () => {
    setVisible(false);
    try {
      sessionStorage.setItem(DISMISS_KEY, 'true');
    } catch {
      /* sessionStorage bloqueado */
    }
  };
  if (!visible) return null;
  const text = NOTICE_TEXT[lang] || NOTICE_TEXT.en;
  return <div role="region" aria-label="Aviso de servicios oficiales" className="bg-sylmar-light border-b border-sylmar/20 text-charcoal" data-id="element-451">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-start gap-3" data-id="element-452">
        <Info className="w-5 h-5 text-sylmar flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-453" />
        <p className="flex-1 text-sm leading-relaxed" data-id="element-454">{text}</p>
        <button type="button" onClick={close} aria-label="Cerrar aviso" className="flex-shrink-0 p-1 -mt-0.5 text-charcoal/60 hover:text-charcoal hover:bg-sylmar/10 rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sylmar" data-id="element-455">
          <X className="w-4 h-4" aria-hidden="true" data-id="element-456" />
        </button>
      </div>
    </div>;
}